import React, { useState, useRef } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import RepairInventoryForm from './RepairInventoryForm'
import * as components from '../../components'
import SlidingPane from 'react-sliding-pane'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { getRights } from '../../state/rights'
import { getLists } from '../../state/lists'

export const AddRepairInventoryPane = ({
  title,
  onSubmit,
  organizations,
  descriptions,
  consignmentsTypes,
}) => {
  const formRef = useRef()
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const { rights } = useSelector((state) => state.userRights)
  const { consignment_type } = useSelector((state) => state.lists)
  const createInventoryItems = (data) => {
    const payload = []
    data.inventory_items.forEach((element) => {
      let obj = { ...data }
      Object.keys(element).forEach((key) => {
        obj[key] = element[key]
      })
      payload.push(obj)
    })

    new rest.RepairInventoryService()
      .makePostRequest(payload)
      .then((response) => {
        onSubmit()
        dispatch(showSuccessToast('Success', 'Repair Inventory Items created.'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  const loadInitialFormData = () => {
    !rights && dispatch(getRights(user))
    !consignment_type && dispatch(getLists('CONSIGNMENT_TYPE'))
  }
  return (
    <>
      <ReactBootstrap.Button
        variant="dark"
        size="sm"
        onClick={() => setIsPaneOpen(true)}
      >
        {components.ICONS.PLUS}
      </ReactBootstrap.Button>
      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        onAfterOpen={loadInitialFormData}
        title={title}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <RepairInventoryForm
          ref={formRef}
          rights={rights}
          organizations={organizations}
          descriptions={descriptions}
          consignment_type={consignment_type}
          onSubmit={createInventoryItems}
          enableBulkMode={true}
        />
      </SlidingPane>
    </>
  )
}
